<script lang="ts">
  import { Check } from "lucide-svelte";

  export let isActive = false;
  export let title: string;
  export let subtitle: string = "";
</script>

<button class="block w-full text-left" on:click>
  <div
    class="flex py-1.5 rounded-md px-2 justify-between items-center"
    class:active={isActive}
    class:hover={!isActive}
  >
    <div class="min-w-0">
      <div
        class="text-white text-sm text-ellipsis overflow-hidden whitespace-nowrap"
      >
        {title}
      </div>
      {#if subtitle}
        <div class="text-xs text-white/60">{subtitle}</div>
      {/if}
    </div>
    <div class="flex-shrink-0">
      {#if isActive}
        <Check color="#7FEE64" size={20} />
      {/if}
    </div>
  </div>
</button>

<style lang="postcss">
  .active {
    @apply bg-primary/10;
  }

  .hover:hover {
    @apply bg-white/10;
  }
</style>
